import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const Cids = props => (
  <SvgIcon {...props} viewBox="0 0 80 80">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Cids" fill="currentcolor" fillRule="nonzero">
        <g id="baseline-spellcheck-24px">
          <g>
            <g>
              <path
                d="M40.8,74.1c-7,0-13.8-2.2-19.5-6.3c-1.4-1-3.2-0.7-4.2,0.7c-1,1.4-0.7,3.2,0.7,4.2c17.8,12.6,42.4,8.4,55-9.3
                c12.6-17.8,8.4-42.4-9.3-55c-1.4-0.9-3.3-0.5-4.2,0.9c-0.9,1.3-0.6,3.1,0.7,4C75,23.9,78.7,44.7,68.1,59.8
                C61.9,68.8,51.7,74.1,40.8,74.1"
                id="Shape"
              />
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="M16.6,56.1c-1.1-0.3-2.2-0.6-3.2-1.1c-1-0.5-1.9-1.1-2.8-1.9c-0.8-0.8-1.6-1.6-2.1-2.6s-1.1-2.1-1.4-3.3
                    c-0.3-1.2-0.5-2.6-0.5-4c0-1.2,0.1-2.4,0.4-3.6c0.3-1.1,0.7-2.2,1.2-3.2c0.5-1,1.2-1.9,1.9-2.7c0.8-0.8,1.7-1.5,2.6-2.1
                    c1-0.6,2.1-1,3.3-1.3s2.6-0.5,4-0.5c1.9,0,3.8,0.4,5.6,1.2c1.6,0.7,3.1,1.8,4.3,3.1c0.3,0.3,0.3,0.9-0.1,1.2l-3.8,3.3
                    c-0.3,0.3-0.8,0.3-1.1,0c-0.2-0.1-0.3-0.3-0.5-0.4c-0.4-0.3-0.8-0.6-1.2-0.8s-1-0.5-1.5-0.6c-0.6-0.2-1.1-0.2-1.7-0.2
                    c-0.6,0-1.3,0.1-1.9,0.3c-0.6,0.2-1.2,0.5-1.7,0.8c-0.5,0.4-1,0.8-1.4,1.3c-0.4,0.5-0.7,1.2-0.9,1.9s-0.3,1.5-0.3,2.4
                    c0,0.9,0.1,1.7,0.4,2.5c0.3,0.8,0.7,1.5,1.2,2.1s1.2,1.1,2,1.4c0.8,0.4,1.7,0.5,2.6,0.5c1,0,2-0.2,3-0.7c0.8-0.4,1.4-0.8,2-1.4
                    c0.3-0.3,0.8-0.3,1.1,0l3.8,3.3c0.3,0.3,0.4,0.8,0.1,1.2c-1.1,1.2-2.4,2.2-4,2.9c-1.8,0.9-3.8,1.4-6,1.4
                    C18.8,56.5,17.7,56.4,16.6,56.1z"
                    id="Shape2"
                  />
                </g>
                <g>
                  <path
                    d="M34,30.3h5.4c0.5,0,0.8,0.4,0.8,0.8v24.2c0,0.5-0.4,0.8-0.8,0.8H34c-0.5,0-0.8-0.4-0.8-0.8V31.1
                    C33.2,30.7,33.6,30.3,34,30.3z"
                    id="Shape3"
                  />
                </g>
                <g>
                  <path 
                    d="M44.2,31.1c0-0.5,0.4-0.8,0.8-0.8h5.6c1.6,0,4.1,0.1,5.7,0.2c0,0,1,0.1,2.7,0.7c1.7,0.6,3.1,1.5,4.2,2.7
                    c1.2,1.1,2,2.5,2.7,4.1c0.6,1.6,0.9,3.4,0.9,5.2s-0.3,3.6-0.9,5.2c-0.6,1.6-1.5,2.9-2.6,4.1c-1.1,1.1-2.5,2-4.2,2.6
                    c-1.7,0.6-2.8,0.7-2.8,0.7c-1.6,0.1-4.1,0.2-5.7,0.2h-5.7c-0.5,0-0.8-0.4-0.8-0.8V31.1z M51.8,50c0.8,0,2.5-0.1,3.8-0.3
                    c0,0,0,0,1-0.6s1.8-1.4,2.3-2.4s0.8-2.1,0.8-3.4c0-0.9-0.2-1.8-0.5-2.7c-0.3-0.8-0.7-1.6-1.3-2.2c-0.6-0.7-1.4-1.2-2.3-1.6
                    c-0.7-0.3-1.4-0.4-2.2-0.4l-1.8,0c-0.5,0-0.8,0.4-0.8,0.8v11.9C50.9,49.6,51.3,50,51.8,50L51.8,50z"
                    id="Shape4"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
)

export default Cids



// WEBPACK FOOTER //
// ./src/icons/Cids.js